<div class="row operateurContainer">
    <div class="col-3 d-flex justify-content-center align-items-center ">
        <button (click)="selectOptionCmp('=')" class="operateur mr-3" [ngClass]="{ 'active': filterAffaire.operateur_cmp === '=' }">
            <fa-icon  [icon]="fa['faEquals']"></fa-icon>
        </button>
<button (click)="selectOptionCmp('!=')"  class="operateur" [ngClass]="{ 'active': filterAffaire.operateur_cmp === '!=' }">
    <fa-icon  [icon]="fa['faNotEqual']"></fa-icon>
</button>
  
    </div>
    <div class="col-9 mt-2">
        <ng-container >
            <mat-form-field class="w-100">
                <mat-label>Compagnie</mat-label>
                <ng-container class="p-3" *ngIf="allCompagnie?.length === 0">
                    <div class="row">
                        <div class="text-center m-auto">
                            <mat-spinner [diameter]="15"></mat-spinner>
                        </div>
                    </div>
                </ng-container>
                <mat-chip-list #Compagnie>
                    <mat-chip *ngFor="let compagnie of ListCompagnies" [selectable]="selectable" [removable]="removable"
                        (removed)="removeCompagnie(compagnie)" (removed)=" EmitFilterAffaire()">
                        {{compagnie}}
                        <fa-icon matChipRemove *ngIf="removable" style="color: gray;" [icon]="fa['faTimes']">
                        </fa-icon>
                    </mat-chip>
                    <input  placeholder="Selectionner Compagnie..." #compagnieInput
                        [formControl]="compagnieFromCtrl" [matAutocomplete]="autoCompagnies"
                        [matChipInputFor]="Compagnie" [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                </mat-chip-list>
                <mat-autocomplete #autoCompagnies="matAutocomplete" (optionSelected)="selectedCompagnie($event)">
                    <mat-option *ngFor="let compagnie of filteredCompagnie | async" [value]="compagnie.siren">
                        {{compagnie.denomination}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </ng-container>
    </div>
   
</div>
<div class="row operateurContainer">
    <div class="col-3 d-flex justify-content-center align-items-center">
        <button (click)="selectOptionGamme('=')" class="operateur mr-3" [ngClass]="{ 'active': filterAffaire.operateur_gamme === '=' }">
            <fa-icon  [icon]="fa['faEquals']"></fa-icon>
        </button>
<button (click)="selectOptionGamme('!=')"  class="operateur" [ngClass]="{ 'active': filterAffaire.operateur_gamme === '!=' }">
    <fa-icon  [icon]="fa['faNotEqual']"></fa-icon>
</button>
    
    </div>
    <div class="col-9 mt-2">
        <ng-container >
            <mat-form-field class="w-100">
                <mat-label>Gammes</mat-label>
                <ng-container class="p-3" *ngIf="allGammes?.length === 0">
                    <div class="row">
                        <div class="text-center m-auto">
                            <mat-spinner [diameter]="15"></mat-spinner>
                        </div>
                    </div>
                </ng-container>
                <mat-chip-list #Gammes>
                    <mat-chip *ngFor="let gammes of ListGammes" [selectable]="selectable" [removable]="removable"
                        (removed)="removeGammes(gammes)" (removed)=" EmitFilterAffaire()">
                        {{gammes}}
                        <fa-icon matChipRemove *ngIf="removable" style="color: gray;" [icon]="fa['faTimes']">
                        </fa-icon>
                    </mat-chip>
                    <input  placeholder="Selectionner Gammes..." #gammeInput
                        [formControl]="gammeFromCtrl" [matAutocomplete]="autoGamme" [matChipInputFor]="Gammes"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                </mat-chip-list>
                <mat-autocomplete #autoGamme="matAutocomplete" (optionSelected)="selectedGammes($event)">
                    <mat-option *ngFor="let gammes of filteredGammes | async" [value]="gammes.id">
                        {{gammes.nom}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </ng-container>
    </div>
  
</div>
<div class="row operateurContainer">
    <div class="col-3 d-flex justify-content-center align-items-center">
        <button (click)="selectOptionProduit('=')" class="operateur mr-3" [ngClass]="{ 'active': filterAffaire.operateur_produit === '=' }">
            <fa-icon  [icon]="fa['faEquals']"></fa-icon>
        </button>
<button (click)="selectOptionProduit('!=')"  class="operateur" [ngClass]="{ 'active': filterAffaire.operateur_produit === '!=' }">
    <fa-icon  [icon]="fa['faNotEqual']"></fa-icon>
</button>
    
    </div>
    <div class="col-9 mt-2">
        <ng-container >
            <mat-form-field class="w-100">
                <mat-label>Produit</mat-label>
                <ng-container class="p-3" *ngIf="allProductBackup?.length === 0">
                    <div class="row">
                        <div class="text-center m-auto">
                            <mat-spinner [diameter]="15"></mat-spinner>
                        </div>
                    </div>
                </ng-container>
                <mat-chip-list #chipList>
                    <mat-chip *ngFor="let product of ListProducts" [selectable]="selectable" [removable]="removable"
                        (removed)="removeProducts(product)" (removed)=" EmitFilterAffaire()">
                        {{product}}
                        <fa-icon matChipRemove *ngIf="removable" style="color: gray;" [icon]="fa['faTimes']"></fa-icon>
                    </mat-chip>
                    <input  placeholder="Selectionner produit..." #ProductsInput
                        [formControl]="ProductsFromCtrl" [matAutocomplete]="auto" [matChipInputFor]="chipList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                </mat-chip-list>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedProducts($event)">
                    <mat-option *ngFor="let product of filteredProducts | async" [value]="product">
                        {{product.libelle}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </ng-container>
    </div>

    </div>
    <div class="row">
    <div class="col-6">
        <mat-form-field class="w-100">
            <input matInput [(ngModel)]="filterAffaire.recheche_num_contrat" (change)=" EmitFilterAffaire()"
                placeholder="Numéro de Contrat"   name="num"
                #num="ngModel">
        </mat-form-field>
        <div *ngIf="num.invalid && (num.dirty || num.touched)" class="message-erreur">
            <div *ngIf="num.errors.pattern">
                <fa-icon [icon]="fa['faExclamationTriangle']"></fa-icon>&nbsp;Seulement des chiffres !
            </div>
        </div>
    </div>
    <div class="col-6">
        <ng-container>
            <mat-form-field class="w-100">
                <mat-label>Classe</mat-label>
                <ng-container class="p-3" *ngIf="allClasse?.length === 0">
                    <div class="row">
                        <div class="text-center m-auto">
                            <mat-spinner [diameter]="15"></mat-spinner>
                        </div>
                    </div>
                </ng-container>
                <mat-chip-list #Classe>
                    <mat-chip *ngFor="let Classe of ListClasse" [selectable]="selectable" [removable]="removable"
                        (removed)="removeClasse(Classe)" (removed)=" EmitFilterAffaire()">
                        {{Classe}}
                        <fa-icon matChipRemove *ngIf="removable" style="color: gray;" [icon]="fa['faTimes']"></fa-icon>
                    </mat-chip>
                    <input (change)=" EmitFilterAffaire()" placeholder="Selectionner Classe..." #classeInput
                        [formControl]="classeFromCtrl" [matAutocomplete]="autoClasse" [matChipInputFor]="Classe"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                </mat-chip-list>
                <mat-autocomplete #autoClasse="matAutocomplete" (optionSelected)="selectedClasse($event)">
                    <mat-option *ngFor="let Classe of filteredClasse | async" [value]="Classe.id">
                        {{Classe.libele}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </ng-container>
    </div>
</div>
<div class="row">
    <div class="col-6">
        <mat-form-field class="w-100">
            <input (change)=" EmitFilterAffaire()" [(ngModel)]="filterAffaire.pan_ttc_min" matInput
                placeholder="PAN TTC MIN" type="number" pattern="[-+]?[0-9]*[.,]?[0-9]+" name="min" #min="ngModel">
        </mat-form-field>
        <div *ngIf="min.invalid && (min.dirty || min.touched)" class="message-erreur">
            <div *ngIf="min.errors.pattern">
                <fa-icon [icon]="fa['faExclamationTriangle']"></fa-icon>&nbsp;Seulement des chiffres !
            </div>
        </div>
    </div>
    <div class="col-6">
        <mat-form-field class="w-100">
            <input (change)=" EmitFilterAffaire()" [(ngModel)]="filterAffaire.pan_ttc_max" matInput
                placeholder="PAN TTC MAX" type="number" pattern="[-+]?[0-9]*[.,]?[0-9]+" name="max" #max="ngModel">
        </mat-form-field>
        <div *ngIf="max.invalid && (max.dirty || max.touched)" class="message-erreur">
            <div *ngIf="max.errors.pattern">
                <fa-icon [icon]="fa['faExclamationTriangle']"></fa-icon>&nbsp;Seulement des chiffres !
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-6">
        <div class="form-group">
            <mat-form-field appearance="fill" class="w-100">
                <mat-date-range-input [rangePicker]="creation">
                    <input [(ngModel)]="pose_du_creation" matStartDate readonly placeholder="Date de Création du"  (click)="openDateCreation()"/>
                    <input [(ngModel)]="pose_au_creation" matEndDate  readonly placeholder="à" (click)="openDateCreation()" />

                </mat-date-range-input>
                <mat-datepicker-toggle class="m-0 p-0" matPrefix [for]="creation">    <mat-icon matDatepickerToggleIcon>
                    <img src="assets/icons/calendar.svg" > 
                  </mat-icon></mat-datepicker-toggle>
                  <img  class="remouveDate" matSuffix  (click)="clearDateCreation()" src="assets/icons/delete-left.svg">
                  <mat-date-range-picker (closed)="EmitFilterAffaire()" [calendarHeaderComponent]="rangeDateCreation" #creation></mat-date-range-picker>
                  
                <!-- <mat-datepicker-toggle matSuffix [for]="creation"></mat-datepicker-toggle>
                <mat-date-range-picker (closed)=" EmitFilterAffaire()" #creation></mat-date-range-picker> -->
            </mat-form-field>
            
        </div>
    </div>
    <div class="col-6">
        <div class="form-group">
            <mat-form-field appearance="fill" class="w-100">
                <mat-date-range-input [rangePicker]="Souscription">
                    <input [(ngModel)]="pose_du_souscription" readonly matStartDate placeholder="Date souscription du" (click)="openDateSouscription()" />
                    <input [(ngModel)]="pose_au_souscription" readonly  matEndDate placeholder="à"  (click)="openDateSouscription()"/>

                </mat-date-range-input>
                <mat-datepicker-toggle class="m-0 p-0" matPrefix [for]="Souscription">    <mat-icon matDatepickerToggleIcon>
                    <img src="assets/icons/calendar.svg" > 
                  </mat-icon></mat-datepicker-toggle>
                  <img  class="remouveDate" matSuffix  (click)="clearDateSouscription()" src="assets/icons/delete-left.svg">
                  <mat-date-range-picker (closed)="EmitFilterAffaire()"  [calendarHeaderComponent]="rangeDateSubscription"  #Souscription></mat-date-range-picker>
<!-- 
                <mat-datepicker-toggle matSuffix [for]="Souscription"></mat-datepicker-toggle>
                <mat-date-range-picker (closed)=" EmitFilterAffaire()" #Souscription></mat-date-range-picker> -->
            </mat-form-field>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-6">
        <div class="form-group">
            <mat-form-field appearance="fill" class="w-100">
                <mat-date-range-input [rangePicker]="Effet">
                    <input [(ngModel)]="date_effet_dossier_du" readonly matStartDate placeholder="Date d'effet du"  (click)="openDateeffet()"/>
                    <input [(ngModel)]="date_effet_dossier_au" readonly matEndDate placeholder="à"  (click)="openDateeffet()"/>

                </mat-date-range-input>
                <mat-datepicker-toggle class="m-0 p-0" matPrefix [for]="Effet">    <mat-icon matDatepickerToggleIcon>
                    <img src="assets/icons/calendar.svg" > 
                  </mat-icon></mat-datepicker-toggle>
                  <img  class="remouveDate" matSuffix  (click)="clearDateeffet()" src="assets/icons/delete-left.svg">
                  <mat-date-range-picker (closed)="EmitFilterAffaire()"  [calendarHeaderComponent]="rangeDateEffet"  #Effet></mat-date-range-picker>

                <!-- <mat-datepicker-toggle matSuffix [for]="Effet"></mat-datepicker-toggle>
                <mat-date-range-picker (closed)=" EmitFilterAffaire()" #Effet></mat-date-range-picker> -->
            </mat-form-field>
        </div>
    </div>
    <div class="col-6">
        <div class="form-group">
            <mat-form-field appearance="fill" class="w-100">
                <mat-date-range-input [rangePicker]="envoi">
                    <input [(ngModel)]="pose_du_date_envoi_res" readonly  matStartDate placeholder="Date d'envoi résiliat.. " (click)="openDateenvoi()" />
                    <input [(ngModel)]="pose_au_date_envoi_res" readonly matEndDate placeholder="du..à" (click)="openDateenvoi()"/>

                </mat-date-range-input>

                <mat-datepicker-toggle class="m-0 p-0" matPrefix [for]="envoi">    <mat-icon matDatepickerToggleIcon>
                    <img src="assets/icons/calendar.svg" > 
                  </mat-icon></mat-datepicker-toggle>
                  <img  class="remouveDate" matSuffix  (click)="clearDateenvoi()" src="assets/icons/delete-left.svg">
                  <mat-date-range-picker (closed)="EmitFilterAffaire()"  [calendarHeaderComponent]="rangeDateEnvoi" #envoi></mat-date-range-picker>


                <!-- <mat-datepicker-toggle matSuffix [for]="envoi"></mat-datepicker-toggle>
                <mat-date-range-picker (closed)=" EmitFilterAffaire()" #envoi></mat-date-range-picker> -->
            </mat-form-field>
        </div>
    </div>
</div>
<div class="row operateurContainer">
    <div class="col-3 d-flex justify-content-center align-items-center">
        <button (click)="selectOptionContrat('=')" class="operateur mr-3" [ngClass]="{ 'active': filterAffaire.operateur_contrat === '=' }">
            <fa-icon  [icon]="fa['faEquals']"></fa-icon>
        </button>
<button (click)="selectOptionContrat('!=')"  class="operateur" [ngClass]="{ 'active': filterAffaire.operateur_contrat === '!=' }">
    <fa-icon  [icon]="fa['faNotEqual']"></fa-icon>
</button>
    
    </div>
    <div class="col-9 mt-2">
        <ng-container >
            <mat-form-field class="w-100">
                <mat-label>Ligne de produit</mat-label>
                <ng-container class="p-3" *ngIf="allProducts?.length === 0">
                    <div class="row">
                        <div class="text-center m-auto">
                            <mat-spinner [diameter]="15"></mat-spinner>
                        </div>
                    </div>
                </ng-container>
                <mat-chip-list #Contrat>
                    <mat-chip *ngFor="let contrat of ListContrat" [selectable]="selectable" [removable]="removable"
                        (removed)="removeContrat(contrat)" (removed)=" EmitFilterAffaire()">
                        {{contrat}}
                        <fa-icon matChipRemove *ngIf="removable" style="color: gray;" [icon]="fa['faTimes']"></fa-icon>
                    </mat-chip>
                    <input  placeholder="Selectionner Contrat..." #contratInput
                        [formControl]="contratFromCtrl" [matAutocomplete]="autoContrat" [matChipInputFor]="Contrat"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                </mat-chip-list>
                <mat-autocomplete #autoContrat="matAutocomplete" (optionSelected)="selectedContrat($event)">
                    <mat-option *ngFor="let contrat of filteredContrat | async" [value]="contrat.id">
                        {{contrat.type}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </ng-container>
    </div>
   
    
</div>
<div class="row operateurContainer">
    <div class="col-3 d-flex justify-content-center align-items-center">
        <button (click)="selectOptionTag('=')" class="operateur mr-3" [ngClass]="{ 'active': filterAffaire.operateur_recherche_tag === '=' }">
            <fa-icon  [icon]="fa['faEquals']"></fa-icon>
        </button>
<button (click)="selectOptionTag('!=')"  class="operateur" [ngClass]="{ 'active': filterAffaire.operateur_recherche_tag === '!=' }">
    <fa-icon  [icon]="fa['faNotEqual']"></fa-icon>
</button>
    
    </div>
    <div class="col-9 mt-2">
        <div class="form-group mb-0">
            <ng-container >
                <mat-form-field class="w-100">
                    <mat-label>Mot-clé</mat-label>
                    <ng-container class="p-3" *ngIf="allTags?.length === 0">
                        <div class="row">
                            <div class="text-center m-auto">
                                <mat-spinner [diameter]="15"></mat-spinner>
                            </div>
                        </div>
                    </ng-container>
                    <mat-chip-list #Tags>
                        <mat-chip *ngFor="let Tags of ListTags" [selectable]="selectable" [removable]="removable"
                            (removed)="removeTags(Tags)" (removed)=" EmitFilterAffaire()">
                            {{Tags}}
                            <fa-icon matChipRemove *ngIf="removable" style="color: gray;" [icon]="fa['faTimes']">
                            </fa-icon>
                        </mat-chip>
                        <input  placeholder="Selectionner Tags..." #tagsInput
                            [formControl]="tagsFromCtrl" [matAutocomplete]="autoTags" [matChipInputFor]="Tags"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                    </mat-chip-list>
                    <mat-autocomplete #autoTags="matAutocomplete" (optionSelected)="selectedTags($event)">
                        <mat-option *ngFor="let Tags of filteredTags | async" [value]="Tags.id">
                            {{Tags.libelle}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </ng-container>
        </div>
    </div>
</div>
<!-- <div class="row">
    <div class="col-6">
        <div class="form-group mb-0">
            <ng-container >
                <mat-form-field class="w-100">
                    <mat-label>{{'opportunities.label.tagsnotcontain' | translate}}</mat-label>
                    <ng-container class="p-3" *ngIf="allTags?.length === 0">
                        <div class="row">
                            <div class="text-center m-auto">
                                <mat-spinner [diameter]="15"></mat-spinner>
                            </div>
                        </div>
                    </ng-container>
                    <mat-chip-list #TagsNeContientPas>
                        <mat-chip *ngFor="let Tags of ListTagsNeContientPas" [selectable]="selectable"
                            [removable]="removable" (removed)="removeTagsNeContientPas(Tags)"
                            (removed)=" EmitFilterAffaire()">
                            {{Tags}}
                            <fa-icon matChipRemove *ngIf="removable" style="color: gray;" [icon]="fa['faTimes']">
                            </fa-icon>
                        </mat-chip>
                        <input (click)=" EmitFilterAffaire()" placeholder="Selectionner Tags..." #tagsNeContientPasInput
                            [formControl]="tagsNeContientPasFromCtrl" [matAutocomplete]="autoTagsNeContientPas"
                            [matChipInputFor]="TagsNeContientPas" [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                    </mat-chip-list>
                    <mat-autocomplete #autoTagsNeContientPas="matAutocomplete"
                        (optionSelected)="selectedTagsNeContientPas($event)">
                        <mat-option *ngFor="let Tags of filteredTagsNeContientPas | async" [value]="Tags.id">
                            {{Tags.libelle}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </ng-container>
        </div>
    </div>
    <div class="col-6">
        <mat-form-field appearance="fill" class="operateur">
            <mat-select (selectionChange)=" EmitFilterAffaire()" [(ngModel)]="filterAffaire.operateur_recheche_not_tag"
                placeholder="Opérateur">
                <mat-option value="OU">
                    Ou
                </mat-option>
                <mat-option value="ET">
                    Et
                </mat-option>

            </mat-select>
        </mat-form-field>
    </div>
   
 
</div> -->
<div class="row">

    <!-- <div class="col-6">
        <div class="form-group">
            <ng-container *ngIf="allRealisation.length > 0">
                <mat-form-field style="width: 100%;margin-top: 11px;">
                    <mat-label>Qui s'occupe de la réalisation ?</mat-label>
                    <mat-chip-list #Realisation>
                        <mat-chip *ngFor="let realisation of ListRealisation" [selectable]="selectable"
                            [removable]="removable" (removed)="removeRealisation(realisation)"
                            (removed)=" EmitFilterAffaire()">
                            {{realisation}}
                            <fa-icon matChipRemove *ngIf="removable" style="color: gray;" [icon]="fa['faTimes']">
                            </fa-icon>
                        </mat-chip>
                        <input (click)=" EmitFilterAffaire()" placeholder="Selectionner ..." #realisationInput
                            [formControl]="realisationFromCtrl" [matAutocomplete]="autoRealisation"
                            [matChipInputFor]="Realisation" [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                    </mat-chip-list>
                    <mat-autocomplete #autoRealisation="matAutocomplete" (optionSelected)="selectedRealisation($event)">
                        <mat-option *ngFor="let realisation of filteredRealisation | async" [value]="realisation.id">
                            {{realisation.libelle}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </ng-container>
        </div>
    </div> -->

      
</div>
